type ActiveBadgeProps = {
  active: boolean;
};

export function ActiveBadge({ active }: ActiveBadgeProps) {
  return (
    <span className={active ? 'badge badge--ok' : 'badge badge--muted'}>
      {active ? 'Activo' : 'Inactivo'}
    </span>
  );
}
